// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__DtIz-","container":"Footer_container__DHOys","bottom":"Footer_bottom__ZPsvv","link":"Footer_link__vUAyM","creator":"Footer_creator__3Tu6j"};